import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppService } from '../../../../app.service';
import { Subscription } from 'rxjs/Subscription';
import { SearchItem } from '../../../../entities';
import { Router } from '@angular/router';

/**
 * This is the inspection search page. From this page the user can
 * navigate to view any of the types of inspections such as:
 * -- Undercarriage Inspection
 * -- Unsynced Inspection
 * -- Rope Shovel Inspection
 * -- Workshop Repair Estimate
 * -- Undercarriage Interpretation
 *
 * This page also uses the shared search component which is also
 * currently in use on the dashboard page. 
 */
@Component({
  selector: 'find-inspection',
  templateUrl: './find-inspection.component.html',
  styleUrls: ['./find-inspection.component.scss']
})
export class FindInspectionComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  currentSearchFilters: SearchItem[] = [];
  TemperatureEnabled:string
  TempEnabled:boolean;
  ThermographyEnabled:boolean;
  ThermographyEnabled_:string;
  WorkshopRepair:boolean;
  inspectionType: 'temperature' | 'thermography' | 'other' = 'other';
  constructor(private _appService: AppService,
    public readonly _router: Router) { }

  ngOnInit() {
    this.initializeSearch();
    this.setInspectionType();
    this._appService.getApplicationConfigValue("TemperatureEnabled").subscribe(result => {
      this.TemperatureEnabled = result
      console.log("this.TemperatureEnabled", this.TemperatureEnabled)
      if(this.TemperatureEnabled=="1"){
          this.TempEnabled = true;
      }else{
          this.TempEnabled=false;
      }
     
  });

  this._appService.getApplicationConfigValue("ThermographyEnabled").subscribe(result => {
    this.ThermographyEnabled_ = result
    console.log("this.ThermographyEnabled_", this.ThermographyEnabled_)
    if(this.ThermographyEnabled_=="1"){
        this.ThermographyEnabled = true;
    }else{
        this.ThermographyEnabled=false;
    }
   
});
  }

  OpenTab(site){
    
    if(site=="estimates"){
      this.WorkshopRepair = true
    }else{
      this.WorkshopRepair=false
    }

    
    if(this._router.url.includes("estimates")){

      this.WorkshopRepair = true
    }else{
      this.WorkshopRepair = false
    }

    if(this._router.url.includes("temperature")){
       this.inspectionType = 'temperature';
    }else if(this._router.url.includes("thermography")){
      this.inspectionType = 'thermography';
    }else{
       this.inspectionType = 'other';
    }

    return this._router.url.includes(site)

  }

  private setInspectionType() {
    if (this._router.url.includes('temperature')) {
      this.inspectionType = 'temperature';
    } else if (this._router.url.includes('thermography')) {
      this.inspectionType = 'thermography';
    } else {
      this.inspectionType = 'other';
    }

    this.WorkshopRepair = this._router.url.includes('estimates');
  }


  
  /**
   * Unsubscribe from all our subscriptions before leaving
   * the page. 
   */
  ngOnDestroy() {
    this.subscriptions.forEach(
      subscription => {
        if (!subscription.closed) subscription.unsubscribe();
      });
  }

  /**
   * Initializes the subscription to the shared search
   * component. Will pre-set the initial selected search filters
   * to whatever the last shared search was in the app state. 
   */
  initializeSearch() {
    this.currentSearchFilters = this._appService.getLastSelectionSearchItems();
    this.subscriptions.push(
      this._appService.getSelectionSearchItems().subscribe(
        searchItems => {
          this.currentSearchFilters = searchItems;
          })
    );
  }

}
